// Print templates for PRIXDEAL poster generation
// Templates: Simple (minimalist) and Tropical (golden frame)

// HTML escape helper to prevent XSS
const esc = (str) => {
    if (str == null) return '';
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
};

import { escapeHtml, safeWriteToWindow } from '../lib/sanitize';

// Safe write to print window with iframe fallback
const safeWritePrint = (printWindow, html) => {
    safeWriteToWindow(printWindow, html);
};

// ========== DISPATCHER ==========
export const printSingleProduct = (product, companyName, model = 'simple') => {
    if (model === 'tropical') {
        printSingleProductTropical(product, companyName);
        return;
    }
    printSingleProductSimple(product, companyName);
};

// Open print window with iframe fallback
const openPrintWindow = (html) => {
    const printWindow = window.open('', '_blank', 'width=800,height=1000');
    if (printWindow && !printWindow.closed) {
        safeWritePrint(printWindow, html);
        return;
    }
    // Fallback: iframe
    try {
        const iframe = document.createElement('iframe');
        iframe.style.cssText = 'position:fixed;top:-10000px;left:-10000px;width:800px;height:1000px;';
        document.body.appendChild(iframe);
        safeWriteToWindow(iframe.contentWindow, html);
        iframe.onload = function() {
            setTimeout(function() { iframe.contentWindow.focus(); iframe.contentWindow.print(); setTimeout(function() { document.body.removeChild(iframe); }, 1000); }, 800);
        };
    } catch (e) {
        alert("Impossible d'ouvrir la fenetre d'impression. Autorisez les popups pour ce site.");
    }
};

// ========== MODEL: SIMPLE (Minimaliste) ==========
const printSingleProductSimple = (product, companyName) => {

    const details = [product.origin, product.caliber, product.category].filter(Boolean).map(d => escapeHtml(d)).join(' | ');

    const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>${escapeHtml(product.name)} - ${escapeHtml(companyName || 'PRIXDEAL')}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Bebas+Neue&display=swap');
*{margin:0;padding:0;box-sizing:border-box;print-color-adjust:exact!important;-webkit-print-color-adjust:exact!important}
@page{size:A4 portrait;margin:0}
html,body{
    font-family:'Oswald',sans-serif;
    width:210mm;height:297mm;max-height:297mm;
    background:#FFFFFF!important;
    display:flex;flex-direction:column;
    align-items:center;justify-content:flex-start;
    padding:0;overflow:hidden;
}
.print-btn{
    position:fixed;top:20px;right:20px;padding:12px 30px;
    background:#1A4D2E!important;color:white!important;
    border:none;border-radius:30px;font-size:16px;font-weight:600;
    cursor:pointer;box-shadow:0 4px 15px rgba(0,0,0,0.2);z-index:1000;
    font-family:'Oswald',sans-serif;letter-spacing:1px;
}
.print-btn:hover{transform:scale(1.05)}
@media print{.print-btn{display:none!important}}

.company-name{
    font-family:'Bebas Neue',sans-serif;
    font-size:72px;letter-spacing:6px;
    color:#1A4D2E!important;text-align:center;
    text-transform:uppercase;
    line-height:1;
    margin-top:15px;
}
.divider{
    width:120px;height:4px;background:#E63946!important;
    margin:10px auto 0;border-radius:2px;
}

.main-content{
    flex:1;display:flex;flex-direction:column;
    align-items:center;justify-content:center;
    padding:15px 50px;width:100%;
    background:#FFFFFF!important;
}
.product-name{
    font-family:'Bebas Neue',sans-serif;
    font-size:72px;letter-spacing:4px;
    color:#222222!important;text-align:center;
    text-transform:uppercase;line-height:1.05;
    margin-bottom:10px;
}
.product-details{
    font-family:'Oswald',sans-serif;
    font-size:24px;font-weight:400;
    color:#666666!important;text-align:center;
    text-transform:uppercase;letter-spacing:3px;
    margin-bottom:25px;
}
.price-row{
    display:flex;align-items:center;justify-content:center;
    gap:25px;margin-bottom:5px;
}
.price-row-img{
    width:180px;height:180px;
    object-fit:contain;flex-shrink:0;
    background:transparent!important;
    border:none;border-radius:0;box-shadow:none;
}
.product-img-top{
    width:200px;height:200px;
    object-fit:contain;
    background:transparent!important;
    border:none;border-radius:0;box-shadow:none;
    margin-bottom:8px;
}
.price-block{
    text-align:center;
}
.price-label{
    font-size:20px;text-transform:uppercase;
    letter-spacing:5px;color:#999!important;
    font-weight:500;margin-bottom:3px;
}
.price-value{
    font-family:'Bebas Neue',sans-serif;
    font-size:280px;line-height:0.82;
    color:#E63946!important;
    letter-spacing:2px;
}
.price-cents{
    font-size:130px;vertical-align:super;
}
.price-euro{
    font-size:80px;color:#E63946!important;
}
.price-unit{
    font-size:28px;color:#999!important;
    letter-spacing:3px;font-weight:400;
    margin-top:3px;
}

.footer-bar{
    width:100%;background:#1A4D2E!important;
    padding:14px 40px;
    display:flex;align-items:center;justify-content:space-between;
    flex-shrink:0;
}
.footer-logo{
    font-family:'Bebas Neue',sans-serif;
    font-size:32px;color:white!important;
    letter-spacing:4px;
}
.footer-contact{
    font-size:13px;color:rgba(255,255,255,0.7)!important;
    text-align:right;line-height:1.5;
}
.qr-placeholder{
    width:50px;height:50px;
    border:2px solid rgba(255,255,255,0.3);
    border-radius:8px;overflow:hidden;
}
.qr-placeholder img{width:100%;height:100%;object-fit:contain;background:white}
</style>
</head>
<body>
<button class="print-btn" onclick="window.print()">IMPRIMER</button>
${companyName ? `<div class="company-name">${escapeHtml(companyName)}</div>` : ''}
<div class="divider"></div>
<div class="main-content">
    ${product.image_url ? `<img class="product-img-top" src="${escapeHtml(product.image_url)}" alt="${escapeHtml(product.name)}" onerror="this.style.display='none'" />` : ''}
    <div class="product-name">${escapeHtml(product.name)}</div>
    ${details ? `<div class="product-details">${details}</div>` : ''}
    <div class="price-block">
        <div class="price-label">Prix</div>
        <div class="price-value">${Math.floor(product.customPrice || product.price || 0)}<span class="price-cents">,${String(Math.round(((product.customPrice || product.price || 0) % 1) * 100)).padStart(2, '0')}</span><span class="price-euro">&euro;</span></div>
        <div class="price-unit">par ${escapeHtml(product.unit)}</div>
    </div>
</div>
<div class="footer-bar">
    <div class="footer-logo">PRIXDEAL</div>
    <div class="qr-placeholder">
        <img src="${window.location.origin}/qrcode-prixdeal.png" alt="QR" onerror="this.parentElement.style.display='none'" />
    </div>
</div>
<script>window.onload=function(){setTimeout(function(){window.print()},800)}</script>
</body>
</html>`;
    openPrintWindow(html);
};

// ========== MODEL: TROPICAL JAUNE ==========
const printSingleProductTropical = (product, companyName) => {

    const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>${escapeHtml(product.name)} - ${escapeHtml(companyName || 'PRIXDEAL')}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=Poppins:wght@400;600;700;900&display=swap');
*{margin:0;padding:0;box-sizing:border-box;print-color-adjust:exact!important;-webkit-print-color-adjust:exact!important}
@page{size:A4;margin:0}
html,body{
    font-family:'Poppins',sans-serif;
    width:100%;min-height:100vh;
    background:#F5A623!important;
    display:flex;align-items:center;justify-content:center;
    padding:30px;position:relative;overflow:hidden;
}
.bg-overlay{
    position:fixed;top:0;left:0;right:0;bottom:0;z-index:0;
    background:linear-gradient(135deg,#FFD700 0%,#F5A623 30%,#FFD700 60%,#FFB347 100%)!important;
}
.print-btn{
    position:fixed;top:20px;right:20px;padding:12px 30px;
    background:linear-gradient(135deg,#1A4D2E,#22C55E)!important;color:white!important;
    border:none;border-radius:30px;font-size:16px;font-weight:600;
    cursor:pointer;box-shadow:0 4px 15px rgba(0,0,0,0.2);z-index:1000;
    font-family:'Poppins',sans-serif;letter-spacing:1px;
}
.print-btn:hover{transform:scale(1.05)}
@media print{.print-btn{display:none!important}}

.poster-frame{
    background:#0D3B1F!important;
    border-radius:40px;padding:50px 45px;max-width:620px;width:100%;
    box-shadow:0 30px 80px rgba(0,0,0,0.4);
    position:relative;overflow:hidden;z-index:1;
}
.leaf-deco{position:absolute;font-size:120px;opacity:0.12;z-index:0;pointer-events:none}
.leaf-tl{top:-10px;left:-10px;transform:rotate(-30deg)}
.leaf-br{bottom:-10px;right:-10px;transform:rotate(150deg)}
.leaf-tr{top:40px;right:-20px;transform:rotate(60deg);font-size:80px;opacity:0.08}
.leaf-bl{bottom:50px;left:-15px;transform:rotate(-60deg);font-size:90px;opacity:0.1}

.company-badge{
    color:white!important;padding:8px 24px;font-size:28px;
    font-weight:900;display:block;margin-bottom:15px;
    letter-spacing:2px;text-transform:uppercase;
    text-shadow:2px 3px 6px rgba(0,0,0,0.3);
    font-family:'Playfair Display',serif;
}
.promo-ribbon{
    position:absolute;top:35px;right:-35px;
    background:#FF416C!important;color:white!important;
    padding:10px 55px;font-size:16px;font-weight:900;transform:rotate(45deg);
    box-shadow:0 5px 20px rgba(255,65,108,0.5);letter-spacing:3px;z-index:5;
}
.image-frame{
    width:300px;height:300px;margin:0 auto 25px;
    border-radius:24px;overflow:hidden;position:relative;z-index:2;
    box-shadow:0 15px 40px rgba(0,0,0,0.35);
    border:4px solid rgba(255,255,255,0.15);
    background:#f5f5f0!important;
}
.image-frame img{width:100%;height:100%;object-fit:cover}
.product-title{
    font-family:'Playfair Display',serif;font-size:40px;font-weight:900;
    color:white!important;text-align:center;margin-bottom:8px;line-height:1.15;
    text-shadow:2px 3px 6px rgba(0,0,0,0.3);position:relative;z-index:2;
}
.product-origin{
    font-size:16px;color:rgba(255,255,255,0.7)!important;text-align:center;
    margin-bottom:25px;position:relative;z-index:2;letter-spacing:0.5px;
}
.price-tag{
    background:#F5A623!important;
    color:#1A4D2E!important;padding:20px 45px;border-radius:24px;
    display:inline-block;text-align:center;position:relative;z-index:2;
    box-shadow:0 10px 30px rgba(255,165,0,0.4);
    border:3px solid rgba(255,255,255,0.3);
}
.price-label{font-size:11px;text-transform:uppercase;letter-spacing:3px;font-weight:700;opacity:0.8}
.price-value{font-size:52px;font-weight:900;line-height:1.1}
.price-unit{font-size:16px;font-weight:600;opacity:0.8}
.season-pill{
    margin-top:20px;background:rgba(255,255,255,0.1)!important;border:1px solid rgba(255,255,255,0.2);
    color:rgba(255,255,255,0.85)!important;padding:8px 22px;border-radius:20px;
    font-size:13px;display:inline-block;position:relative;z-index:2;
}
.footer-area{
    margin-top:35px;text-align:center;position:relative;z-index:2;
}
.footer-logo{font-size:14px;font-weight:600;color:rgba(255,255,255,0.4)!important;margin-bottom:3px}
.footer-contact{font-size:11px;color:rgba(255,255,255,0.3)!important}
</style>
</head>
<body>
<div class="bg-overlay"></div>
<button class="print-btn" onclick="window.print()">IMPRIMER</button>
<div class="poster-frame">
    <div class="leaf-deco leaf-tl">&#127811;</div>
    <div class="leaf-deco leaf-br">&#127811;</div>
    <div class="leaf-deco leaf-tr">&#127807;</div>
    <div class="leaf-deco leaf-bl">&#127807;</div>
    <div class="promo-ribbon">PROMO</div>
    ${companyName ? `<div style="text-align:center"><div class="company-badge">${escapeHtml(companyName)}</div></div>` : ''}
    <div class="image-frame">
        <img src="${escapeHtml(product.image_url)}" alt="${escapeHtml(product.name)}" onerror="this.style.display='none'" />
    </div>
    <h1 class="product-title">${escapeHtml(product.name)}</h1>
    ${product.origin ? `<div class="product-origin">Origine: <strong>${escapeHtml(product.origin)}</strong></div>` : ''}
    <div style="text-align:center">
        <div class="price-tag">
            <div class="price-label">Prix Special</div>
            <div class="price-value">${(product.customPrice || product.price || 0).toFixed(2)} &euro;</div>
            <div class="price-unit">par ${escapeHtml(product.unit)}</div>
        </div>
    </div>
    ${product.season_start && product.season_end ? `
        <div style="text-align:center">
            <div class="season-pill">Saison: ${['Jan','Fev','Mar','Avr','Mai','Juin','Juil','Aout','Sep','Oct','Nov','Dec'][product.season_start-1]} - ${['Jan','Fev','Mar','Avr','Mai','Juin','Juil','Aout','Sep','Oct','Nov','Dec'][product.season_end-1]}</div>
        </div>
    ` : ''}
    <div class="footer-area">
        <div class="footer-logo">PRIXDEAL</div>
        <div class="footer-contact">Marche de Rungis | 06 62 66 76 39 | asaber@prixdeal.fr</div>
    </div>
</div>
<script>window.onload=function(){setTimeout(function(){window.print()},800)}</script>
</body>
</html>`;
    openPrintWindow(html);
};

// ========== PROMOTIONAL POSTER (multi-product) ==========
export const getPromotionalPosterHTML = (products, companyName, { showPrintBtn = true, autoprint = true } = {}) => {
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Offres de la Semaine - ${companyName || 'PRIXDEAL'}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap');
*{margin:0;padding:0;box-sizing:border-box;print-color-adjust:exact!important;-webkit-print-color-adjust:exact!important}
@page{size:A4 portrait;margin:0}
html{height:297mm;overflow:hidden}
body{font-family:'Inter',sans-serif;background:white;padding:8mm;width:210mm;height:297mm;max-height:297mm;margin:0 auto;display:flex;flex-direction:column;overflow:hidden}
${showPrintBtn ? `.print-btn{
    position:fixed;top:15px;right:15px;padding:14px 35px;
    background:#1A4D2E!important;color:white!important;
    border:none;border-radius:30px;font-size:16px;font-weight:700;
    cursor:pointer;box-shadow:0 4px 15px rgba(0,0,0,0.2);z-index:1000;
    font-family:'Inter',sans-serif;letter-spacing:0.5px;
}
.print-btn:hover{transform:scale(1.05)}
@media print{.print-btn{display:none!important}}` : ''}
.poster-header{
    text-align:center;margin-bottom:12px;padding:14px 15px;
    background:linear-gradient(135deg,#1A4D2E 0%,#22C55E 100%)!important;
    color:white!important;border-radius:14px;flex-shrink:0;
}
.company-name{font-size:14px;opacity:0.85;letter-spacing:2px;text-transform:uppercase;margin-bottom:5px}
.poster-title{font-size:28px;font-weight:900;margin:8px 0 4px;text-transform:uppercase;letter-spacing:1px}
.poster-subtitle{font-size:13px;opacity:0.9}
.products-grid{
    display:grid;grid-template-columns:repeat(3,1fr);
    gap:12px;flex:1;overflow:hidden;align-content:start;
}
.product-card-wrapper{position:relative}
.promo-badge{
    position:absolute;top:-6px;right:-6px;z-index:2;
    background:#EF4444!important;color:white!important;
    padding:3px 10px;border-radius:10px;
    font-size:9px;font-weight:700;transform:rotate(4deg);
}
.product-card{
    border:2px solid #e5e7eb;border-radius:12px;
    padding:12px;text-align:center;
    page-break-inside:avoid;background:white;
}
.product-image{width:100%;height:110px;object-fit:cover;border-radius:8px;margin-bottom:8px;background:#f5f5f0}
.product-name{font-weight:700;font-size:13px;color:#1A4D2E;margin-bottom:3px;line-height:1.2}
.product-origin{font-size:10px;color:#666;margin-bottom:6px}
.price-box{
    background:#FEF3C7!important;border:2px dashed #F59E0B;
    border-radius:8px;padding:6px;margin-top:6px;
}
.price-label{font-size:9px;color:#92400E;text-transform:uppercase;font-weight:600}
.price-value{font-size:22px;font-weight:900;color:#B45309}
.price-unit{font-size:11px;color:#92400E}
.poster-footer{
    text-align:center;padding:12px;
    background:#f5f5f0!important;border-radius:12px;
    font-size:10px;color:#666!important;
    margin-top:auto;flex-shrink:0;
}
.footer-inner{display:flex;align-items:center;justify-content:center;gap:15px}
.qr-img{width:60px;height:60px;flex-shrink:0}
.footer-text p{margin:2px 0}
</style>
</head>
<body>
${showPrintBtn ? '<button class="print-btn" onclick="window.print()">IMPRIMER</button>' : ''}
<div class="poster-header">
    ${companyName ? `<div class="company-name">${escapeHtml(companyName)}</div>` : ''}
    <div class="poster-title">Offres de la Semaine</div>
    <div class="poster-subtitle">Fruits & Legumes frais - Qualite professionnelle</div>
</div>
<div class="products-grid">
    ${products.map(p => `
    <div class="product-card-wrapper">
        <div class="promo-badge">PROMO</div>
        <div class="product-card">
            <img src="${escapeHtml(p.image_url)}" alt="${escapeHtml(p.name)}" class="product-image" onerror="this.style.display='none'" />
            <div class="product-name">${escapeHtml(p.name)}</div>
            ${p.origin ? `<div class="product-origin">Origine: ${escapeHtml(p.origin)}</div>` : ''}
            <div class="price-box">
                <div class="price-label">Prix</div>
                <div class="price-value">${(p.customPrice || p.price).toFixed(2)} &euro;</div>
                <div class="price-unit">/ ${escapeHtml(p.unit)}</div>
            </div>
        </div>
    </div>`).join('')}
</div>
<div class="poster-footer">
    <div class="footer-inner">
        <img src="${window.location.origin}/qrcode-prixdeal.png" alt="QR" class="qr-img" onerror="this.style.display='none'" />
        <div class="footer-text">
            <p><strong>PRIXDEAL</strong> - Votre partenaire fruits & legumes en gros</p>
            <p>CENTRA 307, 94586 RUNGIS CEDEX | 06 62 66 76 39</p>
            <p style="font-size:9px;margin-top:3px">Scannez le QR code pour commander sur www.prix-deal.fr</p>
            <p style="font-size:8px">Offres valables dans la limite des stocks disponibles</p>
        </div>
    </div>
</div>
${autoprint ? `<script>window.onload=function(){setTimeout(function(){window.print()},800)}</script>` : ''}
</body>
</html>`;
};

export const printPromotionalPoster = (products, companyName) => {
    const html = getPromotionalPosterHTML(products, companyName);
    openPrintWindow(html);
};
